import { createLoaderImp } from '../../../components/ozmoit/common';
import { getPaymentHubFormFieldsAction } from '../actions/actions';

const {
  useLoaderData: usePaymentHubFormFieldsLoader,
  LoaderConsumerSimple,
  LoaderProvider,
} = createLoaderImp({
  action: getPaymentHubFormFieldsAction,
});

function PaymentHubFormFieldsData({
  children,
  ...props
}: Parameters<typeof LoaderProvider>[0]) {
  return (
    <LoaderProvider {...props}>
      <LoaderConsumerSimple>{children}</LoaderConsumerSimple>
    </LoaderProvider>
  );
}

export { PaymentHubFormFieldsData, usePaymentHubFormFieldsLoader };
